import { S3Client,
  PutObjectCommand,
  GetObjectCommand,
  ListObjectsV2Command,
  PutObjectCommandInput,
  GetObjectCommandInput,
  DeleteObjectCommandInput,
  ListObjectsV2CommandInput,
  DeleteObjectCommand,
  CreateBucketCommand,
  CreateBucketCommandInput,
  ListBucketsCommand,
  DeleteBucketCommandInput,
  DeleteBucketCommand,
  PutBucketPolicyCommand,
  PutBucketPolicyCommandInput,
  GetBucketPolicyCommand,
  GetBucketPolicyCommandInput,
  S3ServiceException,
  DeleteBucketPolicyCommand,
  DeleteBucketPolicyCommandInput,
} from '@aws-sdk/client-s3';
import {
  ACCESS_KEY_ID,
  SECRET_ACCESS_KEY,
  REGION
} from '@/common/constants/s3.constants';

export const isS3Error = (error): error is S3ServiceException => error instanceof S3ServiceException;

export default class awsS3Client {
  private static instance: S3Client;

  // eslint-disable-next-line no-useless-constructor, no-empty-function
  private constructor() {}

  public static getInstance(): S3Client {
    if (!awsS3Client.instance) {
      const s3Client = new S3Client({
        endpoint: `${window.location.origin}/s3proxy/`,
        region: REGION,
        credentials: {
          accessKeyId: ACCESS_KEY_ID,
          secretAccessKey: SECRET_ACCESS_KEY
        },
        forcePathStyle: true,
      });

      s3Client.middlewareStack.add(
        (next) => async (args: any) => {
          args.request.headers['X-Requested-With'] = 'XMLHttpRequest';
          args.request.headers['X-Session-Id'] = '1';
          const result = await next(args);
          return result;
        },
        { step: 'build' }
      );

      awsS3Client.instance = s3Client;
    }

    return awsS3Client.instance;
  }

  public static async putObject(params: PutObjectCommandInput) {
    const command = new PutObjectCommand(params);
    return this.getInstance().send(command);
  }

  public static async getObject(params: GetObjectCommandInput) {
    const command = new GetObjectCommand(params);
    return this.getInstance().send(command);
  }

  public static async deleteObject(params: DeleteObjectCommandInput) {
    const command = new DeleteObjectCommand(params);
    return this.getInstance().send(command);
  }

  public static async listObjects(params: ListObjectsV2CommandInput) {
    const command = new ListObjectsV2Command(params);
    return this.getInstance().send(command);
  }

  public static async createBucket(params: CreateBucketCommandInput) {
    const command = new CreateBucketCommand(params);
    return this.getInstance().send(command);
  }

  public static async listBuckets() {
    const command = new ListBucketsCommand({});
    return this.getInstance().send(command);
  }

  public static async deleteBucket(params: DeleteBucketCommandInput) {
    const command = new DeleteBucketCommand(params);
    return this.getInstance().send(command);
  }

  public static async putBucketPolicy(params: PutBucketPolicyCommandInput) {
    const command = new PutBucketPolicyCommand(params);
    return this.getInstance().send(command);
  }

  public static async validateBucketPolicy(params: PutBucketPolicyCommandInput) {
    const command = new PutBucketPolicyCommand(params);

    command.middlewareStack.add(
      (next) => (args: any) => {
        args.request.headers['x-ostor-validation-only'] = 'true';
        return next(args);
      },
      { step: 'build' }
    );

    return this.getInstance().send(command);
  }

  public static async getBucketPolicy(params: GetBucketPolicyCommandInput) {
    const command = new GetBucketPolicyCommand(params);
    return this.getInstance().send(command);
  }

  public static async deleteBucketPolicy(params: DeleteBucketPolicyCommandInput) {
    const command = new DeleteBucketPolicyCommand(params);
    return this.getInstance().send(command);
  }
}
